import { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";


const MainLayout = ({ children }) => {
  const [open, setOpen] = useState(window.innerWidth < 768 ? false : true);
  return (
    <div className="md:flex block min-h-screen bg-[#212121] text-white">
      {open && <Sidebar setOpen={setOpen}/>}
      <div className="flex-1 flex flex-col">
        <Header open={open} setOpen={setOpen}/>
        <main className="p-6 w-full bg-[#212121]">{children}</main>
      </div>
    </div>
  );
};

export default MainLayout;
